export default __webpack_public_path__ + "static/media/liquidity.980d8319.svg";